import { FormQuestion } from "../../types/FormQuestion"
import { FormSection } from "../../types/FormSection"
import { Question, SectionState } from "../../types/SectionState"

/**
 * normalizeSections
 * ------------------------------------------------
 * DESCRIPTION_HERE
 */

const isOptional = (question: FormQuestion) => {
  const optional = question.ignore_empty || question.input_name === "read-only"
  return optional
}

export const normalizeSections = (sections: FormSection[]) =>
  sections?.reduce<SectionState>((acc, curr) => {
    const childQuestions: Partial<Question>[] = []
    const parentQuestions =
      curr.form_rows
        ?.flatMap((row) => row.form_questions)
        .map((question, index) => {
          if (question.nested_question) {
            const formattedNestedQuestion: Partial<Question> = {
              order: index + 1,
              fieldName: question.nested_question.mapped_field,
              touched: false,
              error: false,
              optional: isOptional(question.nested_question),
              label: question.nested_question.prompt,
              displayValue: "",
            }
            childQuestions.push(formattedNestedQuestion)
          }
          return {
            order: index,
            fieldName: question.mapped_field,
            optional: isOptional(question),
            touched: false,
            error: false,
            label: question.prompt,
            displayValue: "",
            inputName: question.input_name,
          }
        }) || []
    const allQuestions = [...parentQuestions, ...childQuestions]
    return {
      ...acc,
      [curr.section_name]: {
        name: curr.section_name,
        order: curr.order,
        completed: false,
        errors: false,
        touched: false,
        questions: allQuestions || [],
        conditional: !!curr.conditional_section_mapped_field,
      },
    } as SectionState
  }, {})
